module.exports = __webpack_public_path__ + "static/bvaughn-tearing-1-d0f78e6162c99839f882f3ab9b29facc.png";